
//==================BEGIN DEPENDENCIES========================

import 'reflect-metadata';
  
import 'jquery';
  

//==================BEGIN UTILITY========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/utility/js/namespace';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-theme/js/utility/_.debounce';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-theme/js/utility/_grid';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/utility/js/utils';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/utility/js/tests';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/utility/ab-logger/js/ab-logger';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-theme/js/utility/_enquireIt';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/utility/js/jquery.selector.focusable';
  

//==================BEGIN PLUGINS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.min';
   //Must be imported since we are depending on promises for IE
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/polyfills/js/Promise/es6-promise.auto.min';
   //Must be imported since we are depending on promises for IE
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/jquery/jquery-migrate';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/jquery-ui/jquery-ui';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/jquery-ui/jquery.ui.touch-punch.min';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/touchSwipe/jquery.touchSwipe';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/lazyload/js/jquery.lazyload';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/magicSearch/js/magicsuggest';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/literatum/imports';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/plugins/controller/js/controller';
  

//==================BEGIN BASIC========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/basic/base/js/base';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/basic/inputs/js/inputs';
  

//==================BEGIN COMPONENTS========================

import GetFTR from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-core/components/getFTR/js/getFTR';  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/js/components/_tabs';
  

//==================BEGIN WIDGETS========================

import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/node_modules/ui-theme/js/widgets/_book-product';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250507-82ace4c2/ui-products/aiaa/js/widgets/_purchaseOptions-popup';
  

//==================BEGIN GROUPS========================

import './groups/_jcf';

const main = (UX) => {
    const $getFTR = Array.prototype.slice.call(document.querySelectorAll('[data-getFTR-enabled]')),
        $tab = Array.prototype.slice.call(document.getElementsByClassName('tab')),
        $purchasePopup = Array.prototype.slice.call(document.getElementsByClassName('show-purchaseOptions'))

        // "HACK" for active item in secondary navigation
        // It should not be solve this way, but we have nothing better now :/
        // check this LIT-261589 for more info 
        document.querySelector(`.secondary-navigation a[href="${location.pathname}"]`)?.classList.add('active');
        
try {
        UX.controller.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.fieldsCtrl.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($getFTR.length ) {
            UX.getFTR = new GetFTR($getFTR).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($tab.length ) {
            UX.tab.init($tab);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($purchasePopup.length ) {
            UX.purchasePopup.init($purchasePopup);
        }
    } catch (err) {
        console.error(err);
    }
    
}
import './webpack-public-path'
const importPromises = async () => {

    
    const { default: dynamicMain } = await import(/* webpackChunkName: 'dynamic-imports' */ './dynamic-imports');
    const promises = Object.values(await dynamicMain(UX));
    

    
    promises.push(await import(/* webpackChunkName: 'requestidlecallback-polyfill' */ 'requestidlecallback-polyfill'));
    let lazyPromise = new Promise(resolve => {
        window.requestIdleCallback(
            async () => {
                const { default: lazyMain } = await import(/* webpackChunkName: 'lazy-imports' */ './lazy-imports');
                await lazyMain(UX);
                resolve();
            },
            { timeout: 5000 }
        );
    });
    

    promises.push(lazyPromise);

    return Promise.all(promises);
};

const build = async (UX) => {
    
    const isIE = navigator.userAgent.indexOf('MSIE') !== -1
        || navigator.appVersion.indexOf('Trident/') > -1;
    if (isIE) {
        await import(/* webpackChunkName: 'ie-imports' */ './groups/_ie');
    }
    

    main(UX);
    await importPromises();
    try {
        UX.abLogger.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.enquireIt.init();
    } catch (err) {
        console.error(err);
    }
    
};

build(UX).then(() => {
    console.debug('JS LOADED');
});

